import { Download, CalendarCheck } from 'lucide-react';

const fmt = (d) => new Date(d).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });

export const RelocationDownloads = ({ download, compact = false }) => {
  const items = download?.items || [];
  if (items.length === 0) return null;
  return (
    <div className="space-y-6 text-left" data-testid="relocation-downloads">
      {items.map((item, i) => (
        <div key={i} className={compact ? '' : 'bg-[#F5EFE9] rounded-2xl p-6'}>
          {!compact && item.title && <p className="font-display text-xl text-[#1E1622] mb-4">{item.title}</p>}
          <div className="flex flex-wrap gap-3 mb-4">
            {(item.links || []).map((l, j) => (
              <a key={j} href={l.url} target="_blank" rel="noopener noreferrer" data-testid={`relocation-link-${i}-${j}`}
                className="btn-gold text-sm inline-flex items-center gap-2"><Download size={15} /> {l.label || l.filename || 'Download'}</a>
            ))}
          </div>
          {item.plan_url && (
            <div className="rounded-xl bg-[#2D1037] text-[#FAF7F2] p-4 mb-3 flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
              <p className="text-sm text-[#FAF7F2]/80">Enter your move date and visa type to get a printable, dated plan, valid for 12 months.</p>
              <a href={item.plan_url} target="_blank" rel="noopener noreferrer" data-testid={`relocation-plan-${i}`}
                className="flex-shrink-0 inline-flex items-center gap-2 rounded-full border border-[#C5A059] text-[#E5C178] px-4 py-2 text-sm transition-colors duration-200 hover:bg-[#C5A059] hover:text-[#2D1037]">
                <CalendarCheck size={15} /> Build your personal action plan
              </a>
            </div>
          )}
          {item.expires_at && <p className="text-xs text-[#1E1622]/50" data-testid={`relocation-expiry-${i}`}>Download links expire on {fmt(item.expires_at)}. You can get fresh links any time from My Orders.</p>}
        </div>
      ))}
    </div>
  );
};
